import ReviewsBrickPanel from './reviews-brick-panel';
import {
    DEFAULT_REVIEWS_BRICK_CONFIG,
    buildReviewsBrickToken,
    parseReviewsBrickToken
} from './reviews-brick';

const REVIEWS_BRICK_ID = 'reviews';
const REVIEWS_BRICK_TITLE = 'Google Reviews';

const reviewsBrick = {
    id: REVIEWS_BRICK_ID,
    title: REVIEWS_BRICK_TITLE,
    group: 'Reviews',
    insertBehavior: 'configure-before-insert',
    defaultConfig: DEFAULT_REVIEWS_BRICK_CONFIG,
    getLabel: () => REVIEWS_BRICK_TITLE,
    matchToken: (token) => {
        const parsed = parseReviewsBrickToken(token);
        if (!parsed) return null;
        return {
            brickId: REVIEWS_BRICK_ID,
            label: REVIEWS_BRICK_TITLE
        };
    },
    parseToken: parseReviewsBrickToken,
    buildToken: buildReviewsBrickToken,
    Panel: ReviewsBrickPanel
};

export default reviewsBrick;
